<div class="modal-header">
  <button type="button" class="close ml-auto mt-2 mr-2" (click)="activeModal.dismiss('Cross click')" aria-label="Close">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px" viewBox="0 0 22 22"
      version="1.1">
      <title>modal_close@3x</title>
      <defs></defs>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <g id="modal_close" stroke="#116ce5" stroke-width="2">
          <g id="Group-3" transform="translate(1.000000, 1.000000)">
            <path d="M0.454545455,0.454545455 L19.6318392,19.6318392" id="Line"></path>
            <path d="M0.454545455,0.454545455 L19.6318392,19.6318392" id="Line-Copy" transform="translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "></path>
          </g>
        </g>
      </g>
    </svg>
  </button>
</div>

<div class="save-progress modal-body" [ngSwitch]="currentFormType">
  <div class="text-center">
    <div *ngSwitchCase="formTypeEnum.Login">
      <h2 class="modal-title">Sign In</h2>
      <p>Enter your email and password below.</p>
    </div>
    <div *ngSwitchCase="formTypeEnum.SaveYourWork">
      <h2 class="modal-title">Save your progress</h2>
      <p>Enter your email address to save your work. Continue at your own pace.</p>
      <p>Already have an account?
        <a href="javascript:" (click)="changeFormType(formTypeEnum.Login)">Sign in</a>.
      </p>
    </div>
    <div *ngSwitchCase="formTypeEnum.ForgotPassword">
      <h2 class="modal-title">Forgot password</h2>
      <p>Enter your email address to recover your password.</p>
    </div>
    <div *ngSwitchCase="formTypeEnum.LZLogoSaveYourProgress">
      <h2 class="modal-title mb-4">Save your progress before you go</h2>
      <p class="px-2">Not ready to finish your order? Create an account and we’ll save your progress so you can resume anytime.</p>
    </div>
  </div>

  <form [formGroup]="form" *ngIf="currentFormType !== formTypeEnum.LZLogoSaveYourProgress" novalidate>
    <div class="form-group">
      <label class="control-label">Email address</label>
      <input id="guestExistingUserEmail" class="form-control" formControlName="email" type="text" />
    </div>


    <div class="form-group" *ngIf="currentFormType !== formTypeEnum.ForgotPassword">
      <label class="control-label">Password</label>
      <div class="input-group">
        <input #password id="password" class="form-control" formControlName="password" type="password" />
        <div class="input-group-btn">
          <button class="btn btn-primary" (click)="togglePasswordVisibility()">
            <i class="fa fa-eye" *ngIf="isPasswordVisible"></i>
            <i class="fa fa-eye-slash" *ngIf="! isPasswordVisible"></i>
          </button>
        </div>
      </div>
    </div>

    <p *ngIf="currentFormType === formTypeEnum.Login">
      <a href="javascript:" (click)="changeFormType(formTypeEnum.ForgotPassword)">Forgot password?</a>
    </p>

    <p class="text-danger" *ngIf="accountProcessingError">{{ accountProcessingError }}</p>
  </form>
</div>
<ng-container *ngIf="currentFormType !== formTypeEnum.LZLogoSaveYourProgress; else LZLogoSaveYourProgressForm">
    <div class="modal-footer d-block text-center" >
        <p *ngIf="currentFormType === formTypeEnum.SaveYourWork" class="lz-fs-14">By clicking the button, I agree to the
          <a href="https://www.legalzoom.com/legal/general-terms/privacy-policy" target="_blank">Privacy Policy</a> and
          <a href="https://www.legalzoom.com/legal/general-terms/terms-of-use" target="_blank">Terms of Use</a>.
        </p>

        <div [ngSwitch]="currentFormType">
          <button *ngSwitchCase="formTypeEnum.Login" type="button" id="btn-sign-in" class="btn btn-primary btn-sm" (click)="signIn()">
            <span *ngIf="isLoading">
              <i class="fa fa-spinner fa-pulse fa-fw"></i>
            </span>
            <span *ngIf="!isLoading">
              Sign in
            </span>
          </button>
          <button *ngSwitchCase="formTypeEnum.SaveYourWork" type="button" id="btn-create-account" class="btn btn-primary btn-sm" (click)="createMyAccount()">
            <span *ngIf="isLoading">
              <i class="fa fa-spinner fa-pulse fa-fw"></i>
            </span>
            <span *ngIf="!isLoading">
              Create account
            </span>
          </button>
          <button *ngSwitchCase="formTypeEnum.ForgotPassword" type="button" id="btn-forgot-password" class="btn btn-primary btn-sm" (click)="forgotPassword()">
            <span *ngIf="isLoading">
              <i class="fa fa-spinner fa-pulse fa-fw"></i>
            </span>
            <span *ngIf="!isLoading">
              Send password reset
            </span>
          </button>
        </div>
      </div>
</ng-container>
<ng-template #LZLogoSaveYourProgressForm>
    <div class="save-progress modal-footer d-block text-center" *ngIf="currentFormType === formTypeEnum.LZLogoSaveYourProgress">
        <div class="mb-3">
          <button type="button" class="btn btn-primary btn-sm" (click)="openForm(formTypeEnum.SaveYourWork)">
              <span>
                Create account
              </span>
          </button>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="openForm(formTypeEnum.Login)">
          <span>
            Sign in
          </span>
        </button>
      </div>
      <div class="mb-lg-3">
        <button type="button" class="btn btn-link btn-sm btn-block" (click)="gotoHomePage()">
          <span>
            Leave without saving
          </span>
        </button>
      </div>
    </div>
</ng-template>
